import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import TertiaryTopRoundButton from "../../../../components/_utils/CommonButtons/TertiaryTopRoundButton/TertiaryTopRoundButton";
import TopBarButtons from "../../../../components/_utils/CommonButtons/TopBarButton";
import CommonCardDashboard from "../../../../components/_utils/CommonCardDashboard";
import QuickActionCard from "../../../../components/QuickActionCard/QuickActionCard";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { toast_position } from "../../../../redux/features/Settings/Authorization";
import { tdsTxnViewAll } from "../../../../redux/features/transactions/taxTransaction/taxTransactionViewAll";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";

const TaxationTransactionDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [txnCountLoading, setTxnCountLoading] = useState(true);

  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);
  const { tdsTxnViewAllData, tdsTxnViewAllLoading } = useSelector(
    (state) => state?.tdsTxnViewAll,
  );

  const total_count =
    tdsTxnViewAllData?.total_count ?? GlobalConfiguration?.lengthCheckZero;

  const requireApprovalTxnCount =
    tdsTxnViewAllData?.summary?.actionable_transaction_count;

  const pendingTxnCount = tdsTxnViewAllData?.summary?.pending_transaction_count;

  const approvedTxnCount =
    tdsTxnViewAllData?.summary?.approved_transaction_count;

  const onMount = async () => {
    try {
      await dispatch(
        tdsTxnViewAll({
          page: 1,
          page_size: PaginationConfiguration.paginationSmall,
        }),
      );
    } finally {
      setTxnCountLoading(false);
    }
  };

  const hasTDSService =
    Array.isArray(services) && services.includes("VTDSTransaction");

  const isViewAllDisabled =
    !hasTDSService ||
    txnCountLoading ||
    tdsTxnViewAllLoading ||
    total_count === GlobalConfiguration?.lengthCheckZero;

  const handleDatacardClick = (approvalStatus) => {
    const routeMap = {
      approved: "/tax_transaction_dashboard/tax_transaction_view_all",
      pending: "/tax_transaction_dashboard/tax_transaction_view_all",
      require: "/tax_transaction_dashboard/tax_transaction_single_approval",
    };
    navigate(routeMap[approvalStatus], {
      state: {
        approvalStatus,
      },
    });
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    onMount();
  }, [markerData]);

  return (
    <div
      style={{ height: "var(--full-height)" }}
      className={`internalDashboardView bg-primary-bg w-full px-padding-md overflow-y-auto Qlg:px-padding-base pb-padding-md`}
    >
      <div className="h-navbar-height Qsmd:h-navbar-breadcrumb-height"></div>
      <div className="pb-padding-lg">
        <div className="flex flex-col mt-margin-lg Qlg:mx-auto pb-padding-xl Qlg:pb-padding-base max-w-tab-width-normal w-full Qlg:flex-row Qmd:px-padding-md Qlg:px-padding-base mb-margin-md Qlg:mb-margin-base Qlg:relative">
          <div className="Qlg:w-dashboard-left-card-width flex flex-col">
            <div className="w-width-full p-padding-sm fixed top-top-base left-left-base right-right-base bg-text-primary flex items-center z-z-index-tooltip Qlg:hidden rounded-bl-border-radius-sm rounded-br-border-radius-sm">
              <div className="flex flex-row items-center">
                <img
                  src={ICONS?.TAX_TRANSACTION_WITH_BLUE_CIRCLE}
                  alt="TAX_TRANSACTION_BLUE_CIRCLE"
                  className="h-icon-lg w-icon-lg mr-margin-sm"
                />
                <div className="flex flex-col">
                  <div className="flex items-center">
                    <p className="text-primary-bg font-semibold text-base">
                      Tax
                    </p>
                  </div>
                  <p className="text-primary-bg text-xs">Transactions</p>
                </div>
              </div>
            </div>
            <TopBarButtons
              services={services}
              items={[
                {
                  imgColor: "var(--text-primary)",
                  icon: ICONS?.ADD_BUTTON,
                  label: <>Create tax transaction</>,
                  requiredservice: ["CTAXTransaction"],
                  path: "/tax_transaction_dashboard/create_tax_transaction",
                  // onClick: () => {
                  //   sessionStorage.removeItem("recreate_ben");
                  // },
                },
                {
                  imgColor: "var(--text-primary)",
                  icon: ICONS?.ADD_BUTTON,
                  label: <>Upload file</>,
                  requiredservice: ["CTransactionUpload"],
                  // path: "/tax_transaction_dashboard/create_tax_transaction_upload_transaction",
                  onClick: () => {
                    toast.info("Feature coming soon", toast_position);
                  },
                },
              ]}
            />

            <div className="w-full bg-primary-card Qlg:mt-margin-md md:mt-margin-md sm:mt-margin-md mt-margin-md rounded-border-radius-md relative overflow-hidden">
              <h2 className="bg-primary-card flex items-center justify-between pl-padding-md text-text-primary transition-all duration-animation-medium">
                <div className="flex items-center text-sm font-semibold">
                  <img
                    src={ICONS?.APPROVAL_STATUS}
                    alt="transaction header"
                    className="w-icon-sm mr-margin-sm"
                  />
                  Approval statuses
                </div>
                <div className="flex">
                  <div className="border-dividing"></div>
                  <TertiaryTopRoundButton
                    btnText={globalText?.VIEW_ALL}
                    icon={ICONS?.ARROW_RIGHT_WHITE}
                    imgColor="var(--text-primary)"
                    btnType="button"
                    hoverOption="white"
                    handleFunction={() => {
                      if (isViewAllDisabled) return;

                      navigate(
                        "/tax_transaction_dashboard/tax_transaction_view_all",
                      );
                    }}
                    isDisabled={isViewAllDisabled}
                    enabledTextColor={"var(--text-primary)"}
                    enabledBgColor={"var(--primary-card)"}
                    disabledBgColor={"transparent"}
                  />
                </div>
              </h2>

              <div className="flex flex-col Qlg:flex-row gap-gap-base p-padding-base bg-primary-nav">
                <CommonCardDashboard
                  label={globalText?.REQUIRE_APPROVAL}
                  count={
                    services?.includes("ATDSTransaction")
                      ? requireApprovalTxnCount || "00"
                      : "N/A"
                  }
                  color="var(--pending)"
                  onServiceUnavailable={() =>
                    navigate("/feature_not_assigned", {
                      state: { unavailableService: "ATDSTransaction" },
                    })
                  }
                  onClick={() => {
                    if (
                      requireApprovalTxnCount &&
                      requireApprovalTxnCount !== "00"
                    ) {
                      navigate(
                        "/tax_transaction_dashboard/tax_transaction_single_approval",
                      );
                    }
                  }}
                  loader={txnCountLoading || tdsTxnViewAllLoading}
                />

                <div className="border-border border-primary-bg Qsmd:my-margin-md my-margin-base" />
                <CommonCardDashboard
                  label={globalText?.PENDING_TRANSACTIONS}
                  count={pendingTxnCount ?? "00"}
                  color="var(--pending)"
                  onClick={() => {
                    if (pendingTxnCount !== "00") {
                      handleDatacardClick("pending", "");
                    }
                  }}
                  loader={txnCountLoading || tdsTxnViewAllLoading}
                  isDisabled={
                    pendingTxnCount === "00" ||
                    pendingTxnCount === GlobalConfiguration?.lengthCheckZero ||
                    total_count === GlobalConfiguration?.lengthCheckZero
                  }
                />

                <div className="border-border border-primary-bg Qsmd:my-margin-md my-margin-base" />

                <CommonCardDashboard
                  label={globalText?.APPROVED_TRANSACTIONS}
                  count={approvedTxnCount ?? "00"}
                  color="var(--awaiting)"
                  onClick={() => {
                    if (approvedTxnCount !== "00") {
                      handleDatacardClick("approved", "");
                    }
                  }}
                  loader={txnCountLoading || tdsTxnViewAllLoading}
                  isDisabled={
                    approvedTxnCount === "00" ||
                    total_count === GlobalConfiguration?.lengthCheckZero ||
                    approvedTxnCount === GlobalConfiguration?.lengthCheckZero
                  }
                />
              </div>
            </div>

            <div className="w-full mt-margin-md bg-primary-card rounded-t-border-radius-md rounded-b-border-radius-md">
              <h2 className="bg-primary-card flex items-center justify-between px-padding-md py-padding-sm text-sm font-semibold text-text-secondary transition-all duration-animation-medium rounded-t-border-radius-md">
                <span className="flex items-center text-sm font-semibold text-text-primary">
                  <img
                    src={ICONS?.STATISTICS}
                    alt="Statistics Header"
                    className="h-icon-sm mr-margin-sm"
                  />
                  {globalText?.STATISTICS}
                </span>
              </h2>
              <div className="border-border border-primary-bg mx-margin-md"></div>

              <div className="relative w-full lg:py-padding-md overflow-hidden contents lg:block ">
                <div className="flex flex-col items-center justify-center lg:justify-start h-full text-center p-padding-md">
                  <div className="flex flex-col justify-center items-center w-full">
                    <img
                      src={ICONS?.NO_STATISTICS}
                      alt="No Slides"
                      className="mb-margin-sm w-graphic-width-md h-graphic-rectangle-height-md flex-shrink-0"
                    />
                    <p className="text-xs text-text-primary">
                      No statistics available due to the absence of data. Once
                      data is present,
                      <br />
                      statistics will appear.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col Qlg:w-dashboard-right-card-width mt-margin-md Qlg:mt-margin-base Qlg:absolute Qlg:h-full Qlg:right-right-base">
            <div className="w-full">
              <QuickActionCard
                title="More actions"
                labels={["Upload file view all", "MIS report"]}
                labelDisabled={false}
                type={"taxTxn"}
                onClick={(label) => {
                  if (label === "Upload file view all") {
                    toast.info("Feature coming soon!", toast_position);
                    // if ((services || []).includes("VTransactionUpload")) {
                    // navigate(
                    //   "/tax_transaction_dashboard/upload_transactions_view_all",
                    // );
                    // } else {
                    //   navigate("/feature_not_assigned", {
                    //     state: { unavailableService: "VTransactionUpload" },
                    //   });
                    // }
                  }
                  if (label === "MIS report") {
                    const dashboardBasePath =
                      location.pathname.includes("tax_transaction_dashboard") &&
                      "/tax_transaction_dashboard";

                    if ((services || []).includes("SMisUser")) {
                      navigate(`${dashboardBasePath}/generate_mis_report`);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "SMisUser" },
                      });
                    }
                  }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxationTransactionDashboard;
